
import { defineComponent } from 'vue'
import { Config } from "../models/Config";

export default defineComponent({
  name: "Documentation",
  setup() {
    const config: Config = require("../../config.json");
    let swaggerUrl = "";
    const routeNames: any = {
      activeTabName: '/docs/intro',
      introRoute: '/docs/intro',
      searchRoute: '/docs/search',
      usageRoute: '/docs/usage',
      webhooksRoute: '/docs/webhooks',
    };
    return {
      routeNames, swaggerUrl, config
    }
  },
  beforeMount() {
      this.swaggerUrl = this.config.apiUrl;
      if (window.location.pathname === '/docs') {
        this.routeNames.activeTabName = this.routeNames.introRoute;
        this.$router.push(this.routeNames.activeTabName);
      }
      else
        this.routeNames.activeTabName = window.location.pathname;
  },
  methods: {
    changeRoute(routeName: string) {
      if (this.routeNames.activeTabName === routeName) {
        return
      }
      else {
        this.routeNames.activeTabName = routeName;
        this.$router.push(routeName);
      }
    },
    sendToSwagger() {
      window.open(this.swaggerUrl, '_blank');
    }
  }
})
